import React from 'react';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import FreeTicketNg from './FreeTicketNg';
import OddsAdvantageNg from './OddsAdvantageNg';
import { AutomaticOddsAdvantage } from './AutomaticOddsAdvantage';

function ExtrasListNg({ extras }) {
    if (!extras || extras.size === 0) {
        return null;
    }

    return (
        <>
            {extras.map((extra, i) => {
                switch (extra.get('type')) {
                    case 'freeTicket':
                        return (
                            <FreeTicketNg
                                key={i}
                                stake={extra.get('stake')}
                                multiplier={
                                    extras.filter(extra => extra.get('type') === 'automaticOddsAdvantage').size
                                        ? null
                                        : extra.get('multiplier')
                                }
                            />
                        );
                    case 'oddsAdvantage':
                        return (
                            <OddsAdvantageNg
                                key={i}
                                points={extra.get('points')}
                                multiplier={extra.get('multiplier')}
                            />
                        );
                    case 'automaticOddsAdvantage':
                        return (
                            <AutomaticOddsAdvantage
                                key={i}
                                multiplier={extra.get('multiplierAfterEvaluation') || extra.get('multiplier')}
                            />
                        );
                    default:
                        return null;
                }
            })}
        </>
    );
}

ExtrasListNg.propTypes = {
    extras: PropTypes.instanceOf(Immutable.List)
};

export default ExtrasListNg;
